export const cardetailMenuRouter = [{
  // has: 'vehicleDetail',
  path: 'vehicle/detail',
  icon: 'social-buffer',
  name: 'carDetail',
  title: '车辆详情',
  meta: {activeName: 'carRecordList'},
  component: () => import('@/views/gip/record/car-detail.vue')
}]



// WEBPACK FOOTER //
// ./src/router/record/cardetail.js